Minął czas dostępności sesji publicznej
@if (details) {
  <lib-quick-link
    [contextId]="$safeNavigationMigration(details?.publicSessionId)"
    [context]="'PublicSession'"
  ></lib-quick-link>
}

dla klientów
<lib-quick-cover
  [contextId]="details.publicSessionId"
  [context]="'PublicSession'"
  [maxSize]="2048"
></lib-quick-cover>
